exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-redirect-js": () => import("./../../../src/pages/redirect.js" /* webpackChunkName: "component---src-pages-redirect-js" */),
  "component---src-templates-not-available-index-jsx": () => import("./../../../src/templates/NotAvailable/index.jsx" /* webpackChunkName: "component---src-templates-not-available-index-jsx" */)
}

